import {AuthProvider} from '@apps-common/auth-react';
import {setAuthToken as setGraneroAuthToken} from '@apps-common/geocorn-sdk/api';
import {setAuthToken} from '@apps-common/js-client/api/request';
import React, {useCallback} from 'react';
import {useNavigate} from 'react-router';
import App from './App.jsx';
import {authClient} from './auth.js';

/**
 * In React Router v6, a "layout" route needs to be used to wrap routes in
 * the auth context provider (so they can use the `useAuth` hook).
 */
function SecureApp() {
  const navigate = useNavigate();

  /**
   * @type {import('@apps-common/auth/client.js').ChangeListener}
   */
  const onAuthChange = useCallback(state => {
    setAuthToken(state.user?.accessToken || '');
    setGraneroAuthToken(state.user?.accessToken || '');
  }, []);

  return (
    <AuthProvider
      client={authClient}
      navigate={navigate}
      onChange={onAuthChange}
      private
    >
      <App />
    </AuthProvider>
  );
}

export default SecureApp;
